var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCtScanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ct-scan-icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ctscan"
  }, /*#__PURE__*/React.createElement("g", {
    id: "others"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.21086 39.0535C11.3091 45.1494 15.3641 50.2531 20.6544 53.457C25.9449 56.6609 32.128 57.7574 38.1042 56.5515C44.0804 55.3457 49.4625 51.9154 53.2933 46.8711C57.1242 41.8266 59.1555 35.4949 59.0262 29.0017C59.1574 22.4797 57.1087 16.1211 53.2474 11.066C49.3861 6.01095 43.9648 2.58996 37.9555 1.41648C31.9462 0.242998 25.742 1.39378 20.4554 4.66247C15.1686 7.93116 11.1452 13.104 9.10645 19.2535C9.10645 19.2535 20.1737 19.6228 20.2856 19.4778C24.9651 13.4169 27.8622 11.9688 33.265 11.9688C37.4463 12.0481 41.4312 13.8775 44.3619 17.0631C47.2926 20.2488 48.9347 24.5359 48.9347 29.0017C48.9347 33.4674 47.2926 37.7545 44.3619 40.9402C41.4312 44.1258 37.4463 45.9552 33.265 46.0345C30.7341 46.0288 28.2429 45.3635 26.0074 44.0967C23.7719 42.8298 21.8596 40.9995 20.4366 38.7647",
    stroke: "#E5E5E5",
    strokeWidth: 1.85484,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M1.07533 35.4922L32.2507 35.5938C31.9756 36.0595 31.619 36.4614 31.2012 36.7768C30.7834 37.0921 30.3127 37.3145 29.8159 37.4313C28.3187 37.6346 1.03467 37.4769 1.03467 37.4769L1.07533 35.4922Z",
    fill: "#E5E5E5",
    stroke: "#E5E5E5",
    strokeWidth: 1.85484,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.62109 36.8203L18.2801 36.8768",
    stroke: "#E5E5E5",
    strokeWidth: 1.85484,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "animi"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.00198 23.6758H18.5095C18.7779 23.6752 19.0436 23.7318 19.2914 23.8421C19.5392 23.9524 19.764 24.1144 19.9528 24.3185C21.139 25.4809 22.167 26.8156 23.007 28.2836L23.0249 28.3515C23.1009 28.6726 23.107 29.0081 23.0428 29.3321C22.9786 29.6563 22.8458 29.9602 22.6547 30.2207C22.4635 30.4811 22.219 30.6911 21.9401 30.8346C21.6612 30.978 21.3553 31.0509 21.0459 31.0479L3.02828 31.0376C2.49211 31.0373 1.97773 30.8104 1.59703 30.4061C1.21633 30.0019 1.0001 29.4531 0.995366 28.879L0.967863 25.8741C0.965338 25.5864 1.01609 25.301 1.11718 25.0344C1.21827 24.7678 1.3677 24.5253 1.55684 24.3209C1.74598 24.1165 1.97106 23.9542 2.21911 23.8435C2.46716 23.7328 2.73324 23.6758 3.00198 23.6758Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M3.00198 24.082H18.5095C18.7779 24.0815 19.0436 24.139 19.2914 24.2513C19.5392 24.3636 19.764 24.5284 19.9528 24.7362C21.139 25.9194 22.167 27.2779 23.007 28.7721L23.0249 28.8411C23.1009 29.168 23.107 29.5095 23.0428 29.8393C22.9786 30.1692 22.8458 30.4786 22.6547 30.7437C22.4635 31.0087 22.219 31.2225 21.9401 31.3685C21.6612 31.5145 21.3553 31.5888 21.0459 31.5856L3.02828 31.5752C2.49211 31.5749 1.97773 31.3439 1.59703 30.9324C1.21633 30.521 1.0001 29.9624 0.995366 29.3781L0.967863 26.3195C0.965338 26.0267 1.01609 25.7362 1.11718 25.4649C1.21827 25.1936 1.3677 24.9467 1.55684 24.7387C1.74598 24.5306 1.97106 24.3654 2.21911 24.2527C2.46716 24.14 2.73324 24.082 3.00198 24.082Z",
    stroke: "#E5E5E5",
    strokeWidth: 1.85484,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M28.1181 31.736C30.2426 31.736 31.965 29.8695 31.965 27.5671C31.965 25.2649 30.2426 23.3984 28.1181 23.3984C25.9934 23.3984 24.271 25.2649 24.271 27.5671C24.271 29.8695 25.9934 31.736 28.1181 31.736Z",
    fill: "#E5E5E5"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\n#animi{\n    animation: rotateLHand 40s infinite alternate;\n    transform-origin: top left;\ntransform-box: fill-box;\n\n}\n@keyframes rotateLHand{\n    70% {\n       transform: translateX(0px);\n\n    }\n    100% {\n     transform: translateX(-60px);\n \n    }\n}\n"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtScanIcon);
export default __webpack_public_path__ + "static/media/ct-scan-icon.094a359963a4a9d56eada54f9d733363.svg";
export { ForwardRef as ReactComponent };